/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Add_Speaker_TitleInputs */



/**
* | output |
* | --- |
* | "Add Speaker" |
*
* @param {Speakers_Add_Speaker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_speaker_title = /** @type {((inputs?: Speakers_Add_Speaker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Speaker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un intervenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecher hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить динамик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加发言人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar alto-falante")
	return /** @type {LocalizedString} */ ("Add Speaker")
});